import { useMemo } from 'react';
import { path } from 'ramda';
import { debounce } from 'underscore';

import { DELAY_ACTION } from '@interlayer/js/app/components/main/Games/components/GameTile/components/DetailedTile/constants';

import { ENTER_DRAW_ACTION, GAME_EVENTS } from 'js/app/components/main/Games/constants';
import { useGameComponentConfig } from 'js/app/components/main/Games/hooks/useGameComponentConfig';
import { useGameEventDispatch } from 'js/app/components/main/Games/hooks/useGameEventDispatch';
import { useAutoGameLaunch } from 'js/app/components/main/Games/hooks/useGameLaunch';
import { useIsAllCategories } from 'js/app/components/main/Games/hooks/useIsAllCategories';
import { selectActiveCategory, setIsShowBack } from 'js/app/components/main/Games/store/actions';
import { useGamesDispatch, useGamesSelector } from 'js/app/components/main/Games/store/context';
import { useNavigateWithCheckUser } from 'js/app/hooks/navigate/useNavigate/useNavigateWithCheckUser';
import { useScrollToComponent } from 'js/app/hooks/useScrollToComponent';
import { useAppSelector } from 'js/store/hooks';
import { openWindow } from 'js/utils/url.util';

export const useHandlerActionClick = ({
    targetCategoryName,
    config: {
        gameCode,
        linkAction,
        internalLinkUrl,
        externalLinkUrl
    } = {}
}) => {
    const dispatch = useGamesDispatch();
    const scrollToItem = useScrollToComponent();
    const navigate = useNavigateWithCheckUser();
    const isAllCategories = useIsAllCategories();
    const gameEventDispatch = useGameEventDispatch();
    const { enableListOfCategories } = useGameComponentConfig();
    const { isShowBack, gameComponentRef } = useGamesSelector();
    const gameData = useAppSelector(path(['gamesConfiguration', gameCode]));
    const launchGame = useAutoGameLaunch(gameData);

    return useMemo(() => debounce(() => {
        switch (linkAction) {
            case 'gameLaunch': {
                launchGame();
                break;
            }
            case 'internalLink': {
                navigate(internalLinkUrl);

                break;
            }
            case 'externalLink': {
                openWindow(externalLinkUrl, '_blank');

                break;
            }
            case ENTER_DRAW_ACTION: {
                break;
            }
            case 'openCategory':
            default: {
                if (isShowBack) {
                    dispatch(setIsShowBack(false));
                } else {
                    if (gameComponentRef?.current?.getBoundingClientRect().top < 0) {
                        scrollToItem(gameComponentRef);
                    }

                    if (isAllCategories && !enableListOfCategories) {
                        dispatch(setIsShowBack(true));
                    }
                }

                dispatch(selectActiveCategory(targetCategoryName));

                gameEventDispatch({ name: GAME_EVENTS.GAME_PORTLET_CATEGORY_CHANGE });

                break;
            }
        }
    }, DELAY_ACTION), [
        dispatch,
        enableListOfCategories,
        externalLinkUrl,
        internalLinkUrl,
        isShowBack,
        gameEventDispatch,
        launchGame,
        linkAction,
        navigate,
        scrollToItem,
        targetCategoryName,
        gameComponentRef,
        isAllCategories
    ]);
};
